<opac-dialog
  #dialog
  size="small"
  [title]="'user.challenges.createChallenge' | translate"
  (opened)="updateInitialValue()"
  (closed)="closeModal()">
  <p class="subtitle">{{'user.challenges.dailyGoalText' | translate}}</p>

  <form [formGroup]="dailyChallengeFormGroup">
    <div>
      <span>{{ 'user.challenges.hours.text' | translate }}</span>
      <opac-select formControlName="hours">
        <opac-option *ngFor="let hour of hours" [value]="hour">{{ hour }}</opac-option>
      </opac-select>
    </div>

    <div>
      <span>{{ 'user.challenges.minutes.text' | translate}}</span>
      <opac-select formControlName="minutes">
        <opac-option *ngFor="let minute of minutes" [value]="minute">{{ minute }}</opac-option>
      </opac-select>
    </div>
  </form>

  <opac-button slot="actions" (click)="createChallenge()">
    {{ (initialValue() !== undefined ? 'button.update' : 'button.create') | translate }}
  </opac-button>
</opac-dialog>
